import styled from 'styled-components';
import { Button } from '@material-ui/core';

const ButtonSecondary = styled(Button)`
  min-height: 36px;
  padding: 0 20px;
  background: var(--neutral-0);
  border: 1px solid var(--neutral-300);
  border-radius: var(--radius-md);
  color: var(--neutral-700);
  font-family: inherit;
  font-size: var(--fs-base);
  font-weight: var(--fw-medium);
  text-transform: none;
  line-height: 1;
  transition:
    background-color var(--motion-fast) var(--ease-standard),
    border-color var(--motion-fast) var(--ease-standard),
    box-shadow var(--motion-fast) var(--ease-standard);

  &:hover {
    background: var(--neutral-50);
    border-color: var(--neutral-400);
    box-shadow: var(--shadow-xs);
  }

  &:focus-visible {
    box-shadow: var(--shadow-focus);
  }

  &.Mui-disabled {
    color: var(--neutral-400);
    background: var(--neutral-50);
    border-color: var(--neutral-200);
  }
`;

export default ButtonSecondary;
